import { characterSelector, useHudStore } from "@/domains/hud/store";
import HudWeapon from "@/domains/hud/components/HudWeapon";

export default function HudWeaponContainer() {
  const character = useHudStore(characterSelector);

  if (!character?.weapon) return null;

  return (
    <HudWeapon
      value={character.weapon?.value || ""}
      cartridge={character.weapon?.cartridge || 0}
      magazine={character.weapon?.magazine || 0}
    />
  );
}
